import { render, staticRenderFns } from "./SelectPfdoOrganizations.vue?vue&type=template&id=5ef545d2&lang=pug"
import script from "./SelectPfdoOrganizations.vue?vue&type=script&lang=js"
export * from "./SelectPfdoOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports